import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon28: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C9.724 20 9.5 19.776 9.5 19.5C9.5 19.224 9.724 19 10 19C14.971 19 19 14.971 19 10C19 5.029 14.971 1 10 1C9.724 1 9.5 0.776 9.5 0.5C9.5 0.224 9.724 0 10 0ZM10.5 4C10.776 4 11 4.224 11 4.5V10H16.5C16.776 10 17 10.224 17 10.5C17 10.776 16.776 11 16.5 11H10.5C10.224 11 10 10.776 10 10.5V4.5C10 4.224 10.224 4 10.5 4ZM7.5 2H4.5C4.224 2 4 2.224 4 2.5C4 2.776 4.224 3 4.5 3H7.5C7.776 3 8 2.776 8 2.5C8 2.224 7.776 2 7.5 2ZM7.5 17H4.5C4.224 17 4 17.224 4 17.5C4 17.776 4.224 18 4.5 18H7.5C7.776 18 8 17.776 8 17.5C8 17.224 7.776 17 7.5 17ZM7.5 5H1.5C1.224 5 1 5.224 1 5.5C1 5.776 1.224 6 1.5 6H7.5C7.776 6 8 5.776 8 5.5C8 5.224 7.776 5 7.5 5ZM7.5 8H0.5C0.224 8 0 8.224 0 8.5C0 8.776 0.224 9 0.5 9H7.5C7.776 9 8 8.776 8 8.5C8 8.224 7.776 8 7.5 8ZM7.5 11H0.5C0.224 11 0 11.224 0 11.5C0 11.776 0.224 12 0.5 12H7.5C7.776 12 8 11.776 8 11.5C8 11.224 7.776 11 7.5 11ZM7.5 14H1.5C1.224 14 1 14.224 1 14.5C1 14.776 1.224 15 1.5 15H7.5C7.776 15 8 14.776 8 14.5C8 14.224 7.776 14 7.5 14Z"
        fill="#32BBC3"
      />
    </Icon>
  )
}
